import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Analytics from 'analytics-opencare';
import { VisuallyHidden } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import { useAnalyticsService } from 'services/AnalyticsService';

import NewSearch from '../../../common/icons/NewSearch';
import ResumeFunnel from '../../../common/icons/ResumeFunnel';
import {
  OptionBlock,
  OptionDescription,
  OptionTitle,
} from '../../../common/styled-components';
import { useFunnelStorage } from '../../storage/Storage';
import {
  ExistingButton,
  ExistingIconWrapper,
  ExistingWrapper,
  StepWrapper,
} from '../../styled-components';
import { generateStepAnalytics, STEP_KEY } from '../../utils';

const analytics = new Analytics();

const ExistingAnswers = ({ resumeFunnel, clearFunnel }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const location = storage.get(STEP_KEY.LOCATION);
  const city = get(location, 'address.locality');

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_existing-search',
      ...generateStepAnalytics('1', storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const resume = () => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_existing-search',
      name: 'wizard',
      section: 'existing-search',
      ...generateStepAnalytics('1', storage, {
        response: 'return-to-search',
      }),
      position: [1],
    });

    resumeFunnel();
  };

  const clear = () => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_existing-search',
      name: 'wizard',
      section: 'existing-search',
      ...generateStepAnalytics('1', storage, {
        response: 'start-a-new-search',
      }),
      position: [2],
    });

    clearFunnel();
  };

  return (
    <ExistingWrapper data-testid="existing-answers">
      <StepWrapper>
        <OptionBlock row={2}>
          <div>
            <ExistingButton
              data-testid="continue"
              type="button"
              onClick={resume}
            >
              <ExistingIconWrapper aria-hidden>
                <ResumeFunnel color={colors.sage6} />
              </ExistingIconWrapper>
              <OptionTitle aria-hidden>Complete my previous search</OptionTitle>
              <OptionDescription aria-hidden>
                Answer the final few questions and see which dentists we
                recommend in {city}
              </OptionDescription>
              <VisuallyHidden>
                Complete my previous search. Answer the final few questions and
                see which dentists we recommend in {city}
              </VisuallyHidden>
            </ExistingButton>
          </div>
          <div>
            <ExistingButton data-testid="restart" type="button" onClick={clear}>
              <ExistingIconWrapper aria-hidden>
                <NewSearch color={colors.sage6} />
              </ExistingIconWrapper>
              <OptionTitle aria-hidden>Start a new search</OptionTitle>
              <OptionDescription aria-hidden>
                Answer a new set of questions and get matched with the best
                dentists near you
              </OptionDescription>
              <VisuallyHidden>
                Start a new search. Answer a new set of questions and get
                matched with the best dentists near you
              </VisuallyHidden>
            </ExistingButton>
          </div>
        </OptionBlock>
      </StepWrapper>
    </ExistingWrapper>
  );
};

ExistingAnswers.propTypes = {
  resumeFunnel: PropTypes.func.isRequired,
  clearFunnel: PropTypes.func.isRequired,
};

export default ExistingAnswers;
